import { Pipe, PipeTransform } from '@angular/core';
import { DateOrString, MonthsBetweenPipe } from './months-between.pipe';

@Pipe({
    name: 'hasAnnualizedSpend',
    standalone: false
})
export class HasAnnualizedSpendPipe implements PipeTransform {
  transform({
    fromDate,
    toDate,
  }: {
    fromDate: DateOrString;
    toDate: DateOrString;
  }): boolean {
    const monthsBetweenPipe = new MonthsBetweenPipe();
    return monthsBetweenPipe.transform({ fromDate, toDate }) < 12;
  }
}
